import { render, staticRenderFns } from "./EquipamentoMapaIndex.vue?vue&type=template&id=2fa974c4&scoped=true&"
import script from "./EquipamentoMapaIndex.vue?vue&type=script&lang=js&"
export * from "./EquipamentoMapaIndex.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoMapaIndex.vue?vue&type=style&index=0&id=2fa974c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa974c4",
  null
  
)

export default component.exports